module.exports = __webpack_public_path__ + "img/cal.4250d6eb.svg";